export default __webpack_public_path__ + "static/media/julian_sidepanel_pin.051d0398.svg";